import { createSelector } from 'reselect';
import get from 'lodash/get';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import ShippingService from '../services/ShippingService';

const orderBilling = (state) => get(state, 'orderDetails.data.billing', {});
const orderShippingGroup = (state) => get(state, 'orderDetails.data.delivery.groups', {});
const paymentInfo = (state) => state.newPayment;
const orderTotals = (state) => state?.orderDetails?.data?.totals || [];
const bnplDetails = (state) => get(state, 'orderDetails.data.bnpl', {});
// const userAddressList = (state) => state.newShipping?.shipToHomeInfo?.userAddressList || [];
const applePayOrderInfo = (state) => state?.applePayOrderInfo || {};
const orderDetails = (state) => state?.orderDetails?.data || {};

export const selectedCreditCardInfoSelector = createSelector(
    orderBilling,
    orderShippingGroup,
    (billing, shipping) => {
        const orderBillingInfo = get(billing, 'paypal') || get(billing, 'creditCards.cards[0]', {});
        const billingInfo = { ...orderBillingInfo };
        const billingAddressCity = get(billingInfo, 'address.city');
        if (ShippingService.isMilitaryAddress(billingAddressCity)) {
            billingInfo.address.country = billingAddressCity;
        }

        if (isEmpty(billingInfo)) {
            const shippingInfo = find(shipping, { type: 'HOME' }) || {};
            billingInfo.address = shippingInfo.address;
        }
        return billingInfo;
    }
);

export const creditCardUserInputInfoSelector = createSelector(
    paymentInfo,
    (payment) => payment.creditCardUserInputInfo
);

export const registerUserPaymentListSelector = createSelector(
    paymentInfo,
    (payment) => payment.userPaymentList
);

export const selectOrderTotal = createSelector(orderTotals, (totals) => {
    const foundTotal = totals?.find?.((total) => total.type === 'ORDER AMOUNT');
    return foundTotal?.amount || 0;
});

// export const selectBnplAddress = createSelector(userAddressList, (list) => {
//     const noDeleteAddress = list.find((address) => address.showDeleteOption === false);
//     return noDeleteAddress?.source || {};
// });

export const selectEmail = (state) => state.orderContactInfo?.emailId;

export const getBillingAddressInOrderDetails = createSelector(
    orderBilling,
    (billingDetails) =>
        get(billingDetails, 'creditCards.cards[0].address') ||
        get(billingDetails, 'unnamed.address') ||
        get(billingDetails, 'paypal.address')
);

// export const selectBnplAddress = createSelector(
//     getBillingAddressInOrderDetails,
//     orderShippingGroup,
//     (billingAddress, shippingGroup) => {
//         let bnplAddress = { ...billingAddress };
//         if (isEmpty(bnplAddress)) {
//             const homeDelivery = shippingGroup?.find?.((address) => address.type === 'HOME');
//             bnplAddress = { ...homeDelivery?.address };
//         }
//         if (bnplAddress.phone) {
//             const cleanedPhoneNumber = bnplAddress?.phone?.replace?.(/\D/g, '');
//             bnplAddress.phone = cleanedPhoneNumber;
//         }
//         return bnplAddress;
//     }
// );

export const selectCreditCardOnOrder = createSelector(
    orderBilling,
    (billing) => billing.creditCards?.cards?.[0]
);

export const selectBnplOnOrder = createSelector(
    selectCreditCardOnOrder,
    (creditCardOnOrder) => creditCardOnOrder?.subtype === 'BNPL_SYF'
);

export const selectBnplEligible = createSelector(bnplDetails, (bnpl) => bnpl?.bnplEligible);

export const selectBnplIneligibleReason = createSelector(
    bnplDetails,
    (bnpl) => bnpl?.ineligibleReason || {}
);

export const getAppliedGiftCardList = createSelector(
    paymentInfo,
    (payment) => payment?.giftCardInfo?.appliedGiftCardList || []
);

export const selectBnplBlocked = createSelector(
    getAppliedGiftCardList,
    selectBnplEligible,
    selectBnplIneligibleReason,
    (appliedGiftCardList, isBnplEligible, bnplIneligibleReason) => {
        const isBnplSimplyIneligible = !isBnplEligible && !bnplIneligibleReason?.code;
        return isBnplSimplyIneligible || !!appliedGiftCardList.length;
    }
);

export const getShowGiftcardForm = createSelector(
    paymentInfo,
    (payment) => payment?.giftCardInfo?.showGiftCardForm || false
);

export const getApplePayDeviceEligible = createSelector(
    applePayOrderInfo,
    (applePayOrderInfo) => applePayOrderInfo?.applePayAccountEligible || false
);

export const getApplePayInitializeReady = createSelector(
    applePayOrderInfo,
    (applePayOrderInfo) => applePayOrderInfo?.isApplePayInitializeReady || false
);

export const getApplePayOrderEligible = createSelector(
    paymentInfo,
    (payments) => payments?.orderEligibleForApplePay || false
);

export const getOrderPaypalEligible = createSelector(
    paymentInfo,
    (payments) => payments?.payPalEligible || false
);

export const getBagItems = createSelector(
    orderDetails,
    (orderDetails) => orderDetails?.bag?.items || []
);
